<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
            {{ 'bikeshop.shop_setup.card_headers.custom_reservation_questions' | translate }}
</span>
    </div>
  </div>

  <div class="content-container">
    <div class="content">
      <div>
        <div class="column-header">{{ 'bikeshop.rentals.custom_questions.template_header' | translate }}</div>
        <div class="column-description">{{ 'bikeshop.rentals.custom_questions.template_description' | translate }}</div>
        <div class="control-list" cdkDropList #listOne="cdkDropList" [cdkDropListConnectedTo]="[listTwo]">
          <div *ngFor="let template of customQuestionsTemplate" cdkDrag [cdkDragData]="template">
            <span class="hubtiger-dragdrop"></span><span class="fa" [ngClass]="template.icon"></span>
            <div>{{ template.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="column-header">{{ 'bikeshop.rentals.custom_questions.question_control_header' | translate }}</div>
      <div class="column-description">{{ 'bikeshop.rentals.custom_questions.question_control_description' | translate }}
      </div>
      <div class="controls-active-list" cdkDropList #listTwo="cdkDropList" [cdkDropListConnectedTo]="[listOne]"
           (cdkDropListDropped)="dropTemplate($event)">
        <div *ngIf="loading && customQuestions.length === 0"
             style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
          <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
          </p-progressSpinner>
        </div>
        <div *ngFor="let customQuestion of customQuestions;let i = index" class="question">
          <div class="control-type">{{getTypeLabel(customQuestion.controlType)}}</div>
          <div class="row margin-top-16">
            <div class="col-md-4 label">{{'bikeshop.rentals.custom_questions.question' | translate}}:</div>
            <div class="col-md-8"><input pInputText [(ngModel)]="customQuestion.question"/></div>
          </div>
          <div class="row margin-top-8">
            <div class="col-md-4 label">{{'bikeshop.rentals.custom_questions.hint' | translate}}:</div>
            <div class="col-md-8"><input pInputText [(ngModel)]="customQuestion.hint"/></div>
          </div>
          <div class="row margin-top-8" *ngIf="customQuestion.controlType !== 'CHECKBOX'">
            <div class="col-md-4 label">{{'bikeshop.rentals.custom_questions.mandatory' | translate}}:</div>
            <div class="col-md-1">
              <p-inputSwitch [(ngModel)]="customQuestion.mandatory"></p-inputSwitch>
            </div>
          </div>
          <div class="row margin-top-8">
            <div class="col-md-4 label">{{'bikeshop.rentals.custom_questions.select_product_categories' | translate}}
              :
            </div>
            <div class="col-md-8">
              <div class="category-list">
                <div *ngFor="let category of categories"
                     (click)="linkCategory(customQuestion, category.id)"
                     [ngClass]="{'linked': isCategoryLinked(customQuestion, category.id)}">
                  {{category.categoryName}}
                </div>
              </div>
            </div>
          </div>

          <div class="row margin-top-16">
            <div class="col-md-3">
              <button pButton (click)="deleteQuestion(customQuestion, i)"
                      class="p-button-raised full-width alternate"
                      label="{{'bikeshop.general.delete' | translate}}"
                      [disabled]="customQuestion.saving"></button>
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-3">
              <button (click)="saveQuestion(customQuestion, i)"
                      class="iso-round-button full-width"
                      [disabled]="!isValid(customQuestion) || customQuestion.saving"
              >{{'bikeshop.general.save' | translate}}</button>
            </div>
          </div>
        </div>

        <div class="info">{{ 'bikeshop.rentals.custom_questions.drag_drop_info' | translate }}</div>
      </div>

    </div>
  </div>
</div>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
